<template>

  <b-modal 
    v-model="localIsVisible" 
    hide-footer
    size="md"
    @cancel="onCancel"
  >
    <b-card>
      <b-form @submit.prevent="submitForm">

        <b-form-group label="Nombre:" label-for="nombre">
          <b-form-input
            id="nombre"
            v-model="imagen.nombre"
            type="text"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Código:" label-for="codigo">
          <b-form-input
            id="codigo"
            v-model="imagen.codigo"
            type="text"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Precio Neto:" label-for="precioNeto">
          <b-form-input
            id="precioNeto"
            v-model="imagen.precio"
            type="number"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group label-for="establecimiento">
          <label>Establecimiento: <span class="text-danger">*</span></label>
          <validation-provider
            #default="{ errors }"
            name="establecimiento"
            rules="required"
          >
            <v-select
              id="establecimiento"
              v-model="imagen.establecimiento"
              placeholder="Buscar por establecimiento."
              :options="establecimientosOpts"
              :reduce="option => option.value"
              label="text"
              class="d-inline-block w-100"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group label-for="tipoImagen">
          <label>Tipo de Imagen: <span class="text-danger">*</span></label>
          <validation-provider
            #default="{ errors }"
            name="tipoImagen"
            rules="required"
          >
            <v-select
              id="tipoImagen"
              v-model="imagen.tipoImagen"
              placeholder="Buscar por tipo de imagen."
              :options="tipoImagenOpts"
             
              label="text"
              class="d-inline-block w-100"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group label="Estado:" label-for="estado-switch">
          <b-form-checkbox
            id="estado-switch"
            v-model="imagen.estado"
            value="1"
            unchecked-value="0"
            switch
          ></b-form-checkbox>
        </b-form-group>
        
      </b-form>
    </b-card>

    <b-button variant="primary" @click="submitForm">
      Actualizar
    </b-button>
    
  </b-modal>
  
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import vSelect from "vue-select";
import { ValidationProvider } from "vee-validate";
import { establecimientosService } from '@/views/administracion/services';
import { fetchTipoImagenSelect }       from '../services/tipoImagen';

export default {

  name : "ModalEditarImagen",
  
  components: {
    ValidationProvider,
    vSelect,
  },

  props: {
    tokenImagen: {
      type: String,
      default: "",
    },

    isVisible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {

      localIsVisible: this.isVisible,
      tipoImagenOpts: [],
      establecimientosOpts: [],

      imagen: {
        id: "",
        nombre: "",
        codigo: "",
        precioNeto: 0,
        establecimiento: '',
        tipoImagen : null,
        estado: 0,
      },

    };
  },

  async created() {
    this.establecimientosOpts = await establecimientosService.getForSelect();
    this.tipoImagenOpts = await fetchTipoImagenSelect();
  },

  methods: {

    onCancel() {
      this.localIsVisible = false
    },

    salir() {
      this.$router.go(0);
    },


    async submitForm() {
      const precioNetoFormateado = parseInt(this.imagen.precio).toFixed(4);

      const query = `
        mutation actualizarImagen($idImagen: String!, $datos: ImagenInput!) {
          actualizarImagen(imagenDatos: {
              id: $idImagen,
              datos: $datos
          }) {
            imagenActualizado {
              nombre
              codigo
              estado
              precio
              establecimiento{
                id
                Descripcion
              }
              tipoImagen {
                id
                descripcion
              }  
            }

            message
            status
          }
        }
      `;

      const variables = {
        idImagen: this.imagen.id,
        datos: {
          nombre: this.imagen.nombre,
          codigo: this.imagen.codigo,
          precio: precioNetoFormateado,
          establecimiento: this.imagen.establecimiento,
          tipoImagen: this.imagen.tipoImagen.value,
          estado: this.imagen.estado,
        },
      };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });

        if (response.data.data.actualizarImagen.status === "success") {
          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "La imagen se actualizó correctamente.",
          });
          this.$router.go(0);
        } else {
          throw new Error(response.data.data.actualizarImagen.message);
        }
      } catch (error) {
        await this.$swal({
          icon: "error",
          title: "Error",
          text: error.message || "Hubo un problema al actualizar la imagen.",
        });
      }
    },

    async fetchImagen(tokenImagen) {

      if(!tokenImagen) return;

      const query = `
        query ObtenerImagen($tokenimagen: String!) {
          imagen(tokenimagen: $tokenimagen) {
            imagen {
              id
              nombre
              codigo
              estado
              precio
              tipoImagen {
                descripcion
                id
              }
              establecimiento
            }
            message
            status
          }
        }   
      `;

      const variables = {
        tokenimagen: tokenImagen,
      };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });

        if (response.data.data.imagen.status === "Success") {
          if (response.data.data.imagen.imagen) {
            const dataimg = response.data.data.imagen.imagen;
            this.imagen = {
              id: dataimg.id,
              token: dataimg.token,
              nombre: dataimg.nombre,
              codigo: dataimg.codigo,
              estado: dataimg.estado,
              tipoImagen: {value: dataimg.tipoImagen.id, text: dataimg.tipoImagen.descripcion},
              precio: dataimg.precio,
              establecimiento: (dataimg.establecimiento || '').toString().split(',')[0] || ''
              , 
            };
          }
        } else {
          console.error("Error al obtener la imagen:", response.data.message);
        }
      } catch (error) {
        console.error("Error al realizar la consulta GraphQL:", error);
      }
    },
  },

  watch: {
    tokenImagen(newValue) {
      this.fetchImagen(newValue);
    },

    isVisible(newValue) {
      this.localIsVisible = newValue;
    },

    localIsVisible(newValue) {
      this.$emit('update:isVisible', newValue);
    }

  }

};
</script>
